import styled from "styled-components";

import resetBackground from "../../../assets/reset-password-background.jfif";

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  align-items: center;

  width: 100%;
  height: 100vh;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.8);

  background: url(${resetBackground}) no-repeat fixed rgba(0, 0, 0, 0.8);
  overflow: auto;
  background-position: center;
  background-size: cover;

  &::after {
    content: "";
    width: 100%;
    height: 100vh;
    left: 0;
    top: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.8);
  }

  > div {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    > img {
      width: 120px;
      height: 40px;
    }
  }
`;

export const ConfirmIco = styled.div`
  display: flex;
  justify-content: center;
  align-self: center;
  margin-bottom: 20px;

  @media (max-width: 640px) {
    margin-bottom: 10px;
  }

  > img {
    margin: 10px;
  }
`;

export const Text = styled.div`
  margin-bottom: 10px;
  
  > span {
    font-weight: 400;
    font-size: 18px;
    text-transform: none;
    font-size: clamp(0.7rem, 1vw, 1rem);
  }
`;

export const Content = styled.div`
  max-width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px;
  /* width: 400px;   */
`;

export const Information = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 10px 20px;
  background-color: #FFFFFFaa;
  border-radius: 10px;
  width: 100%;
`;

export const Button = styled.button`
  padding: 12px;
  width: 100%;
  letter-spacing: 2px;
  font-weight: 500;
  color: #fff;
  background-color: #008DBE;
  border-radius: 10px;
  font-size: 16px;
  margin-top: 10px;

  cursor: pointer;
  border: none;

    &:focus {
      outline: none;
    }

    &:hover{
      opacity: 0.9;
    }
`;

export const Title = styled.div`
 color: #3B739E;
 font-size: 18px;
 display: flex;
 flex: 1;
 align-items: flex-start;
 margin-bottom: 40px;
 font-weight: bold;
  position: relative;
  left: 0;
 `